import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import { Close } from '@mui/icons-material';

const PRIMARY = '#232536';

export default function Modal({ onClose, children, title, closeOnClickOutside = false }) {
  return (
    <Dialog
      open
      onClose={closeOnClickOutside ? onClose : undefined}
      maxWidth="sm"
      fullWidth
   
      slotProps={{ backdrop: { sx: { backgroundColor: 'rgba(0,0,0,0.50)' } } }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        },
      }}
    >
      {/* Top accent bar */}
      <Box sx={{ height: '4px', backgroundColor: PRIMARY, flexShrink: 0 }} />

      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
          px: 3,
          color: PRIMARY,
          fontWeight: 700,
          fontSize: '1.05rem',
          letterSpacing: '-0.01em',
          lineHeight: 1.4,
        }}
      >
        {title}
        <IconButton
          aria-label="Close modal"
          onClick={onClose}
          size="small"
          edge="end"
          sx={{
            color: '#9ca3af',
            '&:hover': { backgroundColor: 'rgba(35,37,54,0.08)', color: PRIMARY },
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <Box sx={{ height: '1px', backgroundColor: '#e5e7eb', mx: 3 }} />

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          pt: 3,
          pb: 3,
          px: 3,
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
